export default __webpack_public_path__ + "static/media/064-polar bear.95349fe5.svg";